import * as yup from 'yup'

function getProp(range) {
    switch (range) {
        case 'http://www.w3.org/2001/XMLSchema#string':
            return yup.string().nullable()
        case 'http://www.w3.org/2001/XMLSchema#boolean':
            return yup.boolean()
    }

    return null
}

export function getSchemaFromResource(resource) {
    let shape = {}

    if (resource?.writableFields) {
        let i, field, property

        for (i in resource.writableFields) {
            field = resource.writableFields[i]
            property = getProp(field.range)

            if (property) {
                if (field.required) {
                    property = property.required()
                } else {
                    property = property.notRequired()
                }

                shape[field.name] = property
            }
        }
    }

    return yup.object().shape(shape)
}
